export const BRAND_NAME = 'DubSky11';
// Note: It is the main site url. Ex - sky11.com, etc.
export const BRAND_DOMAIN = 'dubsky11.com';
export const PROVIDER_ID = 'BetFair';
